<template>
  <div class="content-block-actions" :class="[{ 'content-block-actions--vertical': vertical }]">
    <div
      :id="`location-button-${childId}`"
      class="content-block-actions__icon"
      data-testid="location-button"
      :class="[{ 'content-block-actions__icon--vertical': vertical }]"
      @click="scrollIntoView(childId)"
    >
      <i class="fal fa-location-circle" />
    </div>

    <div
      :id="`enter-button-${childId}`"
      v-if="isSectionOrPanel(childId)"
      class="content-block-actions__icon"
      data-testid="edit-button"
      :class="[{ 'content-block-actions__icon--vertical': vertical }]"
      @click="enterInAndScroll(childId)"
    >
      <i class="fal fa-pencil" />
    </div>

    <div
      :id="`visible-button-${childId}`"
      v-if="isSectionOrPanel(childId)"
      class="content-block-actions__icon"
      data-testid="visibility-button"
      :class="[{ 'content-block-actions__icon--vertical': vertical }]"
      @click="changeContentVisibility"
    >
      <i :class="`fal fa-${visibilityIcon}`" />
    </div>

    <div
      :id="`remove-button-${childId}`"
      v-if="showDeleteButton"
      class="content-block-actions__icon"
      data-testid="remove-button"
      :class="[{ 'content-block-actions__icon--vertical': vertical }]"
      @click="removeItem(childId)"
    >
      <i class="fal fa-trash-alt" />
    </div>

    <Tooltip placement="right" :target="`location-button-${childId}`" :text="$t('location')" />
    <Tooltip
      placement="right"
      v-if="isSectionOrPanel(childId)"
      :target="`enter-button-${childId}`"
      :text="$t('edit')"
    />
    <Tooltip
      placement="right"
      v-if="isSectionOrPanel(childId)"
      :target="`visible-button-${childId}`"
      text="Visibilidade"
    />
    <Tooltip placement="right" v-if="showDeleteButton" :target="`remove-button-${childId}`" text="Deletar" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'ContentBlockActions',
  props: {
    childId: {
      required: true,
      type: String,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: true,
    }
  },
  mounted() {
    if (this.current) {
      this.visible = this.current.options[this.currentView].visible
    }
  },
  computed: {
    ...mapState('landing', ['currentView']),
    ...mapGetters('landing', ['objectById']),
    current() {
      return this.objectById(this.childId)
    },
    visibilityIcon() {
      return this.visible ? 'eye' : 'eye-slash'
    },
  },
  methods: {
    ...mapActions('ui', ['scrollIntoView']),
    ...mapActions('landing', ['updateOptions', 'setActive', 'batchRemove', 'removeTabs']),
    isSectionOrPanel(id) {
      return id.startsWith('S-') || id.startsWith('P-')
    },
    enterInAndScroll(id) {
      this.setActive(id)
      setTimeout(() => {
        this.scrollIntoView(id)
      }, 300)
    },
    changeContentVisibility() {
      this.visible = !this.visible
      ;['lg', 'md', 'sm'].forEach(size => {
        this.updateOptions({
          id: this.childId,
          path: `${size}.visible`,
          value: this.visible,
        })
      })
    },
    isTabs(id) {
      return id.startsWith('T-')
    },
    removeItem(id) {
      if (this.isSectionOrPanel(id)) {
        this.batchRemove({ id })
      } else if (this.isTabs(id)) {
        this.removeTabs({ id })
      } else {
        this.$emit('delete', id)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content-block-actions {
  display: flex;
}

.content-block-actions--vertical {
  flex-direction: column;
  align-items: center;
}

.content-block-actions__icon {
  cursor: pointer;
  margin-right: 16px;
}

.content-block-actions__icon--vertical {
  margin-right: 0;
}
</style>
